module.exports = __webpack_public_path__ + "98f2be41de2974abfb336d45c7f75bad.svg";